export default{
    layout: "total, sizes, prev, pager, next, jumper",
    storage: "sessionStorage",
    tokenName: "basicStorage",
    debounce: ["doEdit", "config", "survey"],
    errorLog: "development",
    authentication: "intelligence",
}
  